<div class="row">
    <div class="col-md-10">
        <app-shopping-edit></app-shopping-edit>
    </div>
</div>

<hr>

<ul class="list-group">
    <a 
        class="list-group-item" 
        style="cursor: pointer;"              
        *ngFor="let ingreItem of ingredients; let i=index"
        (click)="onEditItem(i)" 
        >{{ ingreItem.name}} - {{ ingreItem.amount }}
        </a>
   
  </ul>
